import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useSetRealityCheck = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.ISetRealityCheckRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.ISetRealityCheckRequestData, TServerSendResponse>({
            ID: 89915,
            responses: [89916, 89900],
            description: 'Set Player Reality Check',
            ...request
        });

        return data;
    }, [
        send
    ]);
};
